import { useGridApiRef as useCommunityGridApiRef } from '@mui/x-data-grid';
export const useGridApiRef = useCommunityGridApiRef;